(async () => {
    const sliderElements = document.querySelectorAll('[data-wm-featured-release]');

    if (!sliderElements.length) return;
 
    sliderElements.forEach((slider) => {
        // Idempotency check: skip if already initialized
        if (slider.dataset.initialized) return;
        slider.dataset.initialized = 'true';

        const state = {
            cursor: null,
            hasNextPage: true,
            isLoading: false,
            swiperInstance: null,
            sectionId: slider.id || 'section-default',
            hasInitialized: false,
            totalProducts: 0
        };

        const wrapper = slider.querySelector('.swiper-wrapper');
        const loadMoreBtn = slider.closest('[data-wm-releases-list-container]')?.querySelector('.js-wm-load-more');

        function createSwiper() {
            return new Swiper(slider, {
                loop: true,
                speed: 1000,
                allowTouchMove: true,
                spaceBetween: 16,
                slidesPerView: 1.2,
                observer: true,
                
                observeParents: true,
                breakpoints: {
                    768: { slidesPerView: 3.5, spaceBetween: 24,slidesOffsetBefore :-40, },
                    1024: { slidesPerView: 3.8, spaceBetween: 32,slidesOffsetBefore :-20},
                    1440: { slidesPerView: 3.8, spaceBetween: 32,slidesOffsetBefore :-60 },
                    
                },
                on: {
                    slideChange: function () {
                        if (!state.hasInitialized) return;
                        const realIndex = this.realIndex;
                        // Trigger load more when we are close to the end of the current products.
                        // We subtract slidesPerView and a small buffer to ensure a seamless transition.
                        const threshold = state.totalProducts - (this.params.slidesPerView || 4) - 1;
                        if (realIndex >= threshold) {
                            loadMoreProducts();
                        }
                    }
                }
            });
        }

        async function loadMoreProducts(count = null) {
            if (!state.hasNextPage || state.isLoading) return;

            state.isLoading = true;

            // Use provided count, or data-load-more-size for subsequent loads,
            // or data-page-size as a fallback.
            const fetchCount = count !== null
                ? count
                : Number(slider.dataset.loadMoreSize || slider.dataset.pageSize || 2);

            console.log(`Loading ${fetchCount} products... cursor:`, state.cursor);

            try {
                const result = await WMStorefrontAPI.getProducts({
                    storeDomain: slider.dataset.storeDomain,
                    apiVersion: slider.dataset.apiVersion,
                    collectionHandle: slider.dataset.collectionHandle,
                    first: fetchCount,
                    after: state.cursor
                });

                const collection = result.collection;
                if (!collection || !collection.products) {
                    console.log('No collection or products found');
                    state.hasNextPage = false;
                    return;
                }

                const products = collection.products.edges;
                const pageInfo = collection.products.pageInfo;

                if (products.length === 0) {
                    console.log('No products in edges');
                    state.hasNextPage = false;
                    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
                    return;
                }

                // Hide load more button if there are no more pages to fetch
                if (!pageInfo.hasNextPage) {
                    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
                }

                state.totalProducts += products.length;

                // Render new slides
                let slidesArray = [];
                products.forEach(edge => {
                    slidesArray.push(WMProductCard.renderProductCard(edge.node, state.sectionId));
                });

                if (state.swiperInstance) {
                    // Use native Swiper method for subsequent loads so a11y indexing and loop updates correctly
                    state.swiperInstance.appendSlide(slidesArray);
                    
                    // Force Swiper to recalculate its layout and loop clones.
                    // Without this, dynamically added slides can cause the Swiper container
                    // to break its flex layout and visually dump all slides on the page.
                    state.swiperInstance.loopDestroy();
                    state.swiperInstance.loopCreate();
                    state.swiperInstance.update();
                } else {
                    // Initial load before Swiper is initialized
                    wrapper.insertAdjacentHTML('beforeend', slidesArray.join(''));
                }

                // Update state
                state.cursor = pageInfo.endCursor;
                state.hasNextPage = pageInfo.hasNextPage;

            } catch (error) {
                console.error('Error loading more products:', error);
            } finally {
                state.isLoading = false;
            }
        }

        async function init() {
            try {
                console.log('Initializing releases list for:', slider.id);

                // First load uses data-page-size.
                // Optimization: If the initial count is 4 or less, we increase it slightly
                // to ensure the carousel is swipeable on large screens (where slidesPerView is 4)
                // without needing a second API call.
                let initialCount = Number(slider.dataset.pageSize || 4);
                if (initialCount <= 4) {
                    initialCount += 2;
                }

                await loadMoreProducts(initialCount);

                console.log('Initial fetch complete. Total products:', state.totalProducts);

                // Initialize Swiper
                if (typeof Swiper === 'undefined') {
                    console.error('Swiper is not defined');
                    return;
                }

                state.swiperInstance = createSwiper();
                state.hasInitialized = true;
                console.log('Swiper initialized successfully');
            } catch (error) {
                console.error('Initialization failed:', error);
            }
        }

        init();

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', async () => {
                await loadMoreProducts();
            });
        }
    });
})();
